import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalCrearSmtpCredential = ({ isOpen, toggle, onSave }) => {
    const [formData, setFormData] = useState({
        id: '',
        usuario: '',
        password: '',
        smtp_host: '',
        port: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSave = () => {
        onSave(formData);
        setFormData({
            id: '',
            usuario: '',
            password: '',
            smtp_host: '',
            port: '',
        }); // Reset
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Crear Credencial SMTP</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="usuario">Usuario</Label>
                        <Input type="text" name="usuario" id="usuario" value={formData.usuario} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="password">Contraseña</Label>
                        <Input type="password" name="password" id="password" value={formData.password} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="smtp_host">Host SMTP</Label>
                        <Input type="text" name="smtp_host" id="smtp_host" value={formData.smtp_host} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="port">Puerto</Label>
                        <Input type="number" name="port" id="port" value={formData.port} onChange={handleChange} />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalCrearSmtpCredential;